import { createIcon } from "@chakra-ui/react";

export const MenuIconDownloads = createIcon({
  displayName: "MenuIconDownloads",
  viewBox: "4 4 16 16",
  path: (
    <path d="M12 13V4M7 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.7348 19.8946 14.4804 19.7071 14.2929C19.5196 14.1054 19.2652 14 19 14H17M16 9L12 14L8 9M17 17H17.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  ),
});
